import React from 'react'
import { useState } from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
/* import { Carousel } from 'react-responsive-carousel' */

import Step from '../step/Step'
import Step1Img from '../../assets/step1.png'
import Step2Img from '../../assets/step2.png'
import Step3Img from '../../assets/step3.png'
/* import Step4Img from '../../assets/step4.png' */
import Step5Img from '../../assets/step5.png'
import SuccessImg from '../../assets/success-blur.png'

import Step1 from './step1/Step1'
import Step2 from './step2/Step2'
import Step3 from './step3/Step3'
/* import Step4 from './step4/Step4' */
import Step5 from './step5/Step5'

import Success from '../success/Success'
import { Alert, Snackbar } from '@mui/material'
import useWidth from '../../hooks/useWidth'

import { StyledGrid /* , useStyles */ } from './styles'
import { smDown } from '../../utils/breakpoints'
import Step25 from './step2-5/Step25'
import { sendLead } from '../../utils/basin'

import axios from 'axios'

const SurveyForm = () => {
  const width = useWidth()
  const cantSteps = 4

  const date = new Date()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const day = String(date.getUTCDate()).padStart(2, '0')
  const year = date.getUTCFullYear()
  const hours = String(date.getUTCHours()).padStart(2, '0')
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')
  const formattedTimestampUTC = `${month}-${day}-${year} ${hours}:${minutes}`

  const [formData, setFormData] = useState({
    step: 1,
    name: '',
    email: '',
    phone: '',
    associationName: '',
    role: '',
    otherRole: '',
    dateSubmission: '',
    services: {},
    otherService: '',
    satisfied: true,
    whyNotSatisfied: '',
    interestedInRecieveProposal: true,
    isWorkOrder: false,
    workOrderNo: '',
    noWorkOrderNo: false,
    workOrderComments: '',
    wordOrderRate: '5',
    orderAditionalComments: '',
    orderRecomend: '',
    wantBeContactedByManagers: false,
    whatDidLike: '',
    whatImprove: '',
    recomendWhy: '',
    rate: 0,
    testimonial: '',
    sending: false,
    msg: '',
    msgType: '',
    dateTime: formattedTimestampUTC,
  })

  /* const classes = useStyles({ step: formData.step }) */

  const handleChange = (evt) => {
    const { name, value } = evt.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleCheckboxServicesChange = (evt) => {
    const { name } = evt.target
    setFormData((previousState) => {
      const services = { ...previousState.services }
      services[name] = !services[name]
      return { ...previousState, services }
    })
  }

  const handleCheckboxChange = (evt) => {
    const { name, checked } = evt.target
    setFormData({
      ...formData,
      [name]: checked,
    })
  }

  const handleNext = () => {
    setFormData({
      ...formData,
      step: formData.step + 1,
    })
  }

  const handleGoto = (st) => {
    setFormData({
      ...formData,
      step: st,
    })
  }

  const handleAlertClose = () => {
    setFormData({
      ...formData,
      msg: '',
      msgType: '',
    })
  }

  const showErrorMsg = (msg) => {
    setFormData({
      ...formData,
      msg: msg,
      msgType: 'error',
    })
  }

  const toggleLoading = () => {
    setFormData({
      ...formData,
      sending: formData.sending,
    })
  }

  const handleSubmit = async () => {
    toggleLoading()
    const spreedSheetUrl = process.env.REACT_APP_API_URL

    const config = {
      mode: 'cors',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }

    const data = new FormData()
    Object.keys(formData).forEach((key) => {
      data.append(
        key,
        typeof formData[key] === 'object'
          ? Object.keys(formData[key])
              .filter((subKey) => formData[key][subKey] === true)
              .join(',')
          : formData[key]
      )
    })

    //save data in google spreed sheet

    await axios
      .post(spreedSheetUrl, data, config)
      .then(async function (response) {
        if (response.status === 200) {
          console.log('data saved in google spreed sheet')

          //send email
          try {
            await sendLead(formData)
            // await sendEmailLead(formData)
            toggleLoading()
            if (formData.rate > 3) {
              setFormData({
                ...formData,
                step: 0,
              })
            } else {
              window.location.reload()
            }
          } catch (err) {
            console.error(err)
            toggleLoading()
            showErrorMsg('Ups! Something went wrong with your feedback.')
          }
        }
      })
      .catch(function (err) {
        console.log(err)
        showErrorMsg('Ups! error when saving data in google spreed sheet')
      })
  }

  return (
    <StyledGrid container>
      <Snackbar
        open={formData.msg ? true : false}
        autoHideDuration={5000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity={formData.msgType || 'error'} sx={{ width: '100%' }}>
          {formData.msg}
        </Alert>
      </Snackbar>
      {/*  <Carousel
        autoPlay={false}
        centerMode={false}
        infiniteLoop={false}
        showArrows={false}
        showStatus={false}
        showIndicators={false}
        selectedItem={formData.step !== 0 ? formData.step - 1 : 6}
        className={classes.carousel}
        showThumbs={false}
        emulateTouch={false}
        swipeable={false}
        useKeyboardArrows={false}
      > */}
      <Step
        open={formData.step === 1}
        img={Step1Img}
        sending={formData.sending}
        data-aos='fade-left'
        bgx={smDown(width) ? '100%' : 'inherit'}
        bgy={smDown(width) ? '100%' : 'inherit'}
        message='Our organization prides itself on providing exceptional services to all who interact with us. We would love to hear your feedback regarding your recent experience. Please take a moment to answer a few questions.'
      >
        <Step1
          btnAction={handleNext}
          handleGoto={handleGoto}
          handleChange={handleChange}
          data={formData}
          cantItems={cantSteps}
          current={1}
        />
      </Step>
      <Step
        open={formData.step === 2}
        img={Step2Img}
        sending={formData.sending}
        data-aos='fade-left'
      >
        <Step2
          btnAction={handleNext}
          handleGoto={handleGoto}
          handleChange={handleCheckboxServicesChange}
          handleInputChange={handleChange}
          data={formData}
          cantItems={cantSteps}
          current={2}
        />
      </Step>
      {!formData.isWorkOrder || formData.isWorkOrder === 'false' ? (
        <Step
          open={formData.step === 3}
          img={Step3Img}
          sending={formData.sending}
          bgx='64%'
        >
          <Step3
            btnAction={handleNext}
            handleGoto={handleGoto}
            handleChange={handleChange}
            data={formData}
            cantItems={cantSteps}
            current={3}
          />
        </Step>
      ) : (
        <Step
          open={formData.step === 3}
          img={Step3Img}
          sending={formData.sending}
          bgx='64%'
        >
          <Step25
            btnAction={handleNext}
            handleGoto={handleGoto}
            handleChange={handleChange}
            handleCheckChange={handleCheckboxChange}
            data={formData}
            cantItems={cantSteps}
            current={3}
          />
        </Step>
      )}
      <Step
        open={formData.step === 4}
        img={Step5Img}
        sending={formData.sending}
        bgy={smDown(width) ? '90%' : '72%'}
      >
        <Step5
          btnAction={handleSubmit}
          handleGoto={handleGoto}
          handleChange={handleChange}
          data={formData}
          cantItems={cantSteps}
          current={4}
        />
      </Step>
      <Success open={formData.step === 0} img={SuccessImg} data={formData} />
      {/* </Carousel> */}
    </StyledGrid>
  )
}

export default SurveyForm
